import type {
  SkeletonProps as ChakraSkeletonProps,
  CircleProps,
} from '@chakra-ui/react';
import { Skeleton as ChakraSkeleton, Circle, Stack } from '@chakra-ui/react';
import * as React from 'react';

export interface SkeletonCircleProps extends ChakraSkeletonProps {
  size?: CircleProps['size'];
}

export const SkeletonCircle = React.forwardRef<
  HTMLDivElement,
  SkeletonCircleProps
>(function SkeletonCircle(props, ref) {
  const { size, ...rest } = props;
  return (
    <Circle size={size} asChild ref={ref}>
      <ChakraSkeleton {...rest} />
    </Circle>
  );
});

export interface SkeletonTextProps extends ChakraSkeletonProps {
  noOfLines?: number;
}

export const SkeletonText = React.forwardRef<HTMLDivElement, SkeletonTextProps>(
  function SkeletonText(props, ref) {
    const { noOfLines = 3, gap, ...rest } = props;
    return (
      <Stack gap={gap} width="full" ref={ref}>
        {Array.from({ length: noOfLines }).map((_, index) => (
          <ChakraSkeleton
            height="4"
            key={index}
            {...props}
            _last={{ maxW: '80%' }}
            {...rest}
          />
        ))}
      </Stack>
    );
  },
);

export const SkeletonLoading = React.forwardRef<
  HTMLDivElement,
  SkeletonTextProps
>(function SkeletonText(props, ref) {
  const { noOfLines = 1, gap, ...rest } = props;
  return (
    <Stack gap={gap} width="full" ref={ref}>
      {Array.from({ length: noOfLines }).map((_, index) => (
        <ChakraSkeleton
          variant="shine"
          height="4"
          key={index}
          {...props}
          // _last={{ maxW: '80%' }}
          css={{
            '--start-color': 'rgba(191, 112, 110, 0.2)', // terracotta.500 with 20% opacity
            '--end-color': 'rgba(20, 184, 166, 0.2)', // teal.500 with 20% opacity
          }}
          {...rest}
        />
      ))}
    </Stack>
  );
});

export const Skeleton = ChakraSkeleton;
